import React, { useRef, useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/Navbar.css";
import { NavbarContext } from "../NavbarContext";

const Navbar = () => {
  const { navbarActive, setNavbarActive, setScrollPosition } = useContext(NavbarContext);
  const menuMobileRef = useRef(null);
  const menuMobileIconRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 699);

  const handleNavbarToggle = () => {
    if (!navbarActive) {
        const currentScroll = window.scrollY || document.documentElement.scrollTop;
        setScrollPosition(currentScroll);
    }

    setNavbarActive(!navbarActive);
  }

  const resetNavbar = () => {
    setNavbarActive(false);
    setScrollPosition(0);
  }

  useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 599);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="navbar-header">
      {!isMobile ? (
        <nav className="navbar-container">
          <div className="navbar-logo">
            <Link to="/">VRD Géothermie</Link>
          </div>
          <ul className="navbar-links">
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">Qui sommes-nous</Link></li>
            <li><Link to="/contact" className="navbar-devis-btn">Contact</Link></li>
          </ul>
        </nav>
      ) :
      (
        <div className="navbar-mobile">
            <div className="navbar-logo">
              <Link to="/">VRD Géothermie</Link>
            </div>
            <div className="navbar-menu-icon" onClick={handleNavbarToggle} ref={menuMobileIconRef}>
                <svg className={`navbar-hamburger-icon ${navbarActive ? "active" : ""}`} width="100" height="100" viewBox="0 0 100 100">
                    <g filter="url(#a)"><rect width="57" height="9" x="44" y="52" rx="4.5"/><rect width="45" height="9" x="44" y="69" rx="4.5"/><rect width="51" height="9" x="44" y="86" rx="4.5"/></g><defs><filter id="a" width="395" height="343" x="-106" y="-94" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="4"/><feGaussianBlur stdDeviation="75"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_450_2451"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_450_2451" result="shape"/></filter></defs>
                </svg>
            </div>
            <nav aria-label="mobile navigation" className={`navbar-sidebar ${navbarActive ? "active" : ""}`} ref={menuMobileRef} >
                <Link onClick={resetNavbar} to="/" className="navbar-sidebar-link">Accueil</Link>
                <Link onClick={resetNavbar} to="/services" className="navbar-sidebar-link">Services</Link>
                <Link onClick={resetNavbar} to="/about" className="navbar-sidebar-link">Qui sommes-nous</Link>
                <Link onClick={resetNavbar} to="/contact" className="navbar-sidebar-link">Contact</Link>
            </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
